import React from 'react';
import { FaCopy } from 'react-icons/fa';

// The endpoint's route, promoted out of a dark code block into a light,
// prominent bar — a teal method pill + the path in monospace + a copy button.
// This is the single most important line on an endpoint page, so it reads like
// the address you call, not like sample code. Accepts either the explicit
// {method, path, onCopy} props or the CodeBox-style {insideRequest, insideText,
// handleCopy} aliases, so it's a drop-in for the old endpoint CodeBoxes.
export const EndpointBar = ({
  method,
  path,
  onCopy,
  insideRequest,
  insideText,
  handleCopy,
}) => {
  const verb = method || insideRequest || 'GET';
  const route = path || insideText || '';
  const copy = onCopy || handleCopy;

  return (
    <div className='doc-ep'>
      <span className='doc-ep__method'>{verb}</span>
      <code className='doc-ep__path'>{route}</code>
      {copy && (
        <button
          type='button'
          className='doc-ep__copy'
          title='Copy'
          onClick={copy}
        >
          <FaCopy /> Copy
        </button>
      )}
    </div>
  );
};

// A dark code block with a header bar (language label + copy button). Used
// throughout the docs for both request examples (non-array: method + path) and
// JSON response examples (isArray: pre-split, className-tagged lines).
export const CodeBox = ({
  isArray,
  wrapperClass,
  arrayToMap,
  insideNumber,
  insideRequest,
  insideText,
  handleCopy,
  apiClass,
  showCopyButton = true,
  lang,
}) => {
  const label = lang || (isArray ? 'JSON' : 'HTTP');

  return (
    <div className={`mt-3 ${wrapperClass}`}>
      <div className='codeBlock'>
        <div className='codeBlock__bar'>
          <span className='codeBlock__lang'>{label}</span>
          {showCopyButton && (
            <button
              type='button'
              className='codeBlock__copy'
              title='Copy'
              onClick={handleCopy}
            >
              <FaCopy /> Copy
            </button>
          )}
        </div>
        <div className={`blackBox ${apiClass ? apiClass : ''}`}>
          {isArray ? (
            arrayToMap.map((item, index) => (
              <div key={index} className='blackBox__inside'>
                <span className='blackBox__inside__text'>
                  <span className={item.className}>{item.text}</span>
                </span>
              </div>
            ))
          ) : (
            <div className='blackBox__inside'>
              <span className='blackBox__inside__text'>
                {insideRequest} <span>{insideText}</span>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
